import _ from 'lodash';
import moment from 'moment-timezone';

import {
  getDropoffWindowFromDropoffWindowString,
  getDropoffWindowStringFromDropoffWindowTimes,
} from 'local_modules/get_delivery_time';

import './style.styl';

angular.module(__filename, []).directive(
  'dropOffDay',
  ngInject(() => ({
    restrict: 'E',
    scope: {
      modelValue: '=ngModel',
      expanded: '=',
      foodhub: '=',
      dayLabel: '@',
    },
    template: require('./template'),
    controllerAs: 'ctrl',
    bindToController: true,
    require: 'ngModel',
    controller: ngInject(function(activeDropoffWindowOptions) {
      this.name = this.dayLabel != null ? this.dayLabel.toLowerCase() : undefined;
      this.isEditing = this.expanded;

      this.activeDropoffWindowOptions = _.without(
        activeDropoffWindowOptions,
        'third-party-carrier',
      );
      this.dropoffWindowString = getDropoffWindowStringFromDropoffWindowTimes(
        this.modelValue.dropoffWindow,
      );

      if (
        (this.modelValue.confirmationDeadline != null
          ? this.modelValue.confirmationDeadline.timeOfDay
          : undefined) != null
      ) {
        this.deadlineTime = moment(this.modelValue.confirmationDeadline.timeOfDay, 'HH:mm');
      }

      this.updateDeadlineTime = () =>
        (this.modelValue.confirmationDeadline.timeOfDay = moment(this.deadlineTime).format(
          'HH:mm',
        ));
      this.getDeliveryWindowSize = () =>
        moment.duration(moment(this.startTime).diff(this.endTime)).humanize();

      this.dayOfDropoff = () => {
        if (!this.modelValue.confirmationDeadline) {
          return;
        }
        return moment(this.dayLabel, 'dddd')
          .subtract(this.modelValue.confirmationDeadline.leadingDays, 'days')
          .format('ddd');
      };

      this.formatDeadline = () => moment(this.deadlineTime).format('h:mma');

      this.toggleEdit = () => (this.isEditing = !this.isEditing);

      this.updateDropoffWindow = () =>
        (this.modelValue.dropoffWindow = getDropoffWindowFromDropoffWindowString(
          this.dropoffWindowString,
        ));

      this.editButtonText = () => {
        if (this.isEditing) {
          return 'Hide';
        }
        return 'Edit';
      };

      return this;
    }),
  })),
);

export default __filename;
